import { RID } from '@sharefiledev/sfplugin-resource-id';
import { RequestListEntityType } from '../types';

export function getItemRID(resourceId: string) {
	const rid = RID.parse(resourceId);
	const itemRID = rid.findEntityType(RequestListEntityType.item);
	if (!itemRID) {
		throw new Error(`No request list resource found for: ${resourceId}`);
	}
	return itemRID;
}
